import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { GridLayout } from '@gem/call/CallView/Shared/GridLayout/GridLayout';
import { FULL_GRID_VIEW_SIZE } from '@gem/call/CallView/constants/views';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';
import { customScrollStyles } from '@gem/ui-kit';

import styles from './CompactScreenVideoLayout.styles.m.css';

export const CompactScreenVideoLayout = observer(() => {
  const getClassName = (opponentsLength: number): string => {
    const mainClassName =
      opponentsLength >= FULL_GRID_VIEW_SIZE
        ? styles.videoLayoutFullGrid
        : styles[`videoLayout${opponentsLength}`];

    return classNames(styles.videoLayout, mainClassName, customScrollStyles.container);
  };

  return (
    <GridLayout
      avatarLargeType={AvatarTypes.Round_40}
      avatarMediumType={AvatarTypes.Round_40}
      getClassName={getClassName}
    />
  );
});
